module.exports = __webpack_public_path__ + "static/10-fe73666f68f64b5f083fd29707f5da68.jpeg";